import { StylesConfig } from "react-select";
import { LangE } from "../../../../../models/enums";
import { customSelectInputStyles } from "../../../../../components/Form/customSelectStyles";

// Set a fixed width for the Select component (adjust as necessary)
const SELECT_FIXED_WIDTH = 140;

export const broadcasterSelectStyles = (
  lang: LangE
): StylesConfig<any, false> => ({
  ...customSelectInputStyles(lang),
  control: (base, state) => ({
    ...base,
    minHeight: "28px",
    height: "28px",
    marginTop: 0,
    fontSize: "0.8rem",
    borderRadius: 4,
    borderColor: "#d1d1d1",
    boxShadow: "none",
    width: SELECT_FIXED_WIDTH, // Fixed width
    minWidth: SELECT_FIXED_WIDTH, // Ensure minimum width
    maxWidth: SELECT_FIXED_WIDTH, // Ensure maximum width
    background: state.isDisabled ? COLORS.backgroundDisabled : COLORS.background,
    "&:hover": {
      borderColor: COLORS.border,
    },
  }),
  valueContainer: (base) => ({
    ...base,
    padding: "0 8px",
    height: "28px",
  }),
  input: (base) => ({
    ...base,
    margin: 0,
    padding: 0,
  }),
  indicatorsContainer: (base) => ({
    ...base,
    height: "28px",
  }),
  dropdownIndicator: (base) => ({
    ...base,
    padding: 2,
  }),
  clearIndicator: (base) => ({
    ...base,
    padding: 2,
  }),
  menu: (base) => ({
    ...base,
    fontSize: "0.85rem",
    zIndex: 10000,
    width: SELECT_FIXED_WIDTH, // Fixed width for dropdown menu
    minWidth: SELECT_FIXED_WIDTH,
    maxWidth: SELECT_FIXED_WIDTH,
  }),
  option: (base, state) => ({
    ...base,
    fontSize: "0.85rem",
    padding: "6px 10px",
    backgroundColor: state.isFocused ? "#f1f1f7" : "#fff",
    color: COLORS.darkGray,
  }),
  container: (base) => ({
    ...base,
    width: SELECT_FIXED_WIDTH,
  }),
  menuPortal: (base) => ({
    ...base,
    zIndex: 10000,
  }),
});
// Example color variables for Select styles - adapt these to match your project's variable usage if needed.
export const COLORS = {
  background: "#fff",
  backgroundDisabled: "#f6f6f6",
  border: "#d1d1d1",
  highlight: "#f1f1f7",
  mainGray: "#8b8b8b",      // $main-gray from scss
  darkGray: "#333333",      // $dark-gray from scss
  blue: "#3969ee",          // $blue from scss
  borderGray: "#e6e6e6",    // $border-gray from scss
};
